const QUARTER_LABEL = /\bQ[1-4]\s+\d{4}\b/;

/**
 * Makes quarter period labels explicit that data is inclusive through that quarter.
 * Examples: "Q1 2026" → "Through Q1 2026", "Safe-T · Q1 2026" → "Safe-T · Through Q1 2026"
 */
export function formatThroughQuarterLabel(label: string | undefined | null): string {
  if (label == null) {
    return '';
  }

  const trimmed = label.trim();
  if (!trimmed) {
    return label;
  }

  if (/^through\b/i.test(trimmed)) {
    return label;
  }

  if (!QUARTER_LABEL.test(trimmed)) {
    return label;
  }

  return trimmed.replace(QUARTER_LABEL, (match, offset) => {
    const before = trimmed.slice(0, offset);
    if (/through\s+$/i.test(before)) {
      return match;
    }
    return `Through ${match}`;
  });
}
